import { render } from "./overtime-model.vue?vue&type=template&id=0ba0e3f0"
import script from "./overtime-model.vue?vue&type=script&lang=js"
export * from "./overtime-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__